import React, { useEffect } from 'react';

const WistiaPlayer = () => {
  useEffect(() => {
    // Load Wistia scripts
    const script1 = document.createElement('script');
    script1.src = "https://fast.wistia.com/player.js";
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement('script');
    script2.src = "https://fast.wistia.com/embed/6xzqhb4md1.js";
    script2.async = true;
    script2.type = "module";
    document.body.appendChild(script2);

    return () => {
      // Cleanup if needed (usually Wistia handles this)
    };
  }, []);

  return (
    <div className="w-full relative rounded-3xl overflow-hidden shadow-2xl border-4 border-zinc-800 bg-zinc-900 group">
      <style>{`
        wistia-player[media-id='6xzqhb4md1']:not(:defined) { 
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/6xzqhb4md1/swatch'); 
          display: block; 
          filter: blur(5px); 
          padding-top:56.25%; 
        }
      `}</style>
      <wistia-player media-id="6xzqhb4md1" aspect="1.7777777777777777">
        <div className="wistia_preload_transcript_outer_wrapper" style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-56.25%' }}>
          <div className="wistia_preload_transcript_inner_wrapper" style={{ overflow: 'auto' }}>
            <p className="wistia_preload_transcript_text" aria-hidden="true" tabIndex="-1" style={{ textAlign: 'justify', fontSize: '5px !important' }}>
              Siempre quise estudiar en el extranjero, pero mi inglés estaba, bueno, estaba horrible, la verdad. La forma en que enseñan aquí es increíble, ¿eh? Es como si supieran exactamente dónde estoy batallando. Nada de lecciones aburridas
            </p>
          </div>
        </div>
      </wistia-player>
      <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
         <p className="text-white text-xs font-bold uppercase tracking-widest">Testimonio Real de Estudiante</p>
      </div>
    </div>
  );
};

export default WistiaPlayer;